import React, { Component } from 'react'
import actions from 'redux/actions'
import PropTypes from 'prop-types'
import { constants, snowplow } from 'common/helpers'
import { FormattedMessage, FormattedHTMLMessage } from 'sb-react-intl'

import Button from 'components/buttons/Button/Button'
import ModalFooter from 'components/modal/ModalFooter/ModalFooter'
import Modal from 'components/modal/Modal/Modal'

import messages from './messages'
import s from './PauseSuccessModal.scss'


const placement = 'pause success popup'

class PauseSuccessModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
  }

  static defaultProps = {
    name: constants.modals.pauseSubscription.PauseSuccess,
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  unpause = () => {
    snowplow.track(constants.snowplowEvents.unpauseClick, { placement }, false)
    actions.models.subscription.unpause({ placement })
      .then(this.close)
  }

  render() {
    const { name } = this.props

    return (
      <Modal
        name={name}
        title={messages.title}
      >
        <FormattedHTMLMessage tag="div" {...messages.text} />
        <Button className={s.button} brand title={messages.buttonOk} onClick={this.close} />
        <ModalFooter>
          <FormattedMessage {...messages.didNotMean} />
          <FormattedMessage className={s.reactivateLink} onClick={this.unpause} {...messages.reactivate} />
        </ModalFooter>
      </Modal>
    )
  }
}


export default PauseSuccessModal
